import type { SeedGroupTranslations } from './seed-group-templates.ts';

export const SEED_GROUP_TRANSLATIONS_ES: SeedGroupTranslations = {
  groups: {
    studio_apartment: {
      name: 'Apartamento tipo estudio',
      description: 'Estancia, cocina y un baño.',
      notes: 'Distribución inicial. Las cantidades y los tiempos son estimados que puede editar.',
    },
    one_bed_apartment: {
      name: 'Apartamento de 1 dormitorio',
      description: 'Un dormitorio, estancia, cocina y un baño.',
      notes: 'Distribución inicial. La cantidad del grupo es cuántas unidades iguales hay.',
    },
    two_bed_apartment: {
      name: 'Apartamento de 2 dormitorios',
      description: 'Dos dormitorios, estancia, cocina y dos baños.',
      notes: 'Distribución inicial. La cantidad del grupo es cuántas unidades iguales hay.',
    },
    three_bed_apartment: {
      name: 'Apartamento de 3 dormitorios',
      description: 'Tres dormitorios, estancia, cocina y dos baños.',
      notes: 'Distribución inicial. Una cantidad de 40 cotiza cuarenta de estos.',
    },
    four_bed_apartment: {
      name: 'Apartamento de 4 dormitorios',
      description: 'Cuatro dormitorios, estancia, cocina y dos baños.',
      notes: 'Distribución inicial. Las cantidades son estimados que puede editar.',
    },
    one_bed_house: {
      name: 'Casa de 1 dormitorio',
      description: 'Casa de un dormitorio con estancia, comedor, cocina, baño y lavandería.',
      notes: 'Distribución inicial. Los tiempos son estimados editables.',
    },
    two_bed_house: {
      name: 'Casa de 2 dormitorios',
      description: 'Casa de dos dormitorios.',
      notes: 'Distribución inicial. Los tiempos son estimados editables.',
    },
    three_bed_house: {
      name: 'Casa de 3 dormitorios',
      description: 'Casa de tres dormitorios.',
      notes: 'Distribución inicial. Los tiempos son estimados editables.',
    },
    four_bed_house: {
      name: 'Casa de 4 dormitorios',
      description: 'Casa de cuatro dormitorios.',
      notes: 'Distribución inicial. Los tiempos son estimados editables.',
    },
    move_out: {
      name: 'Limpieza de mudanza',
      description: 'Cocina, baños y las tareas profundas que suele llevar una mudanza.',
      notes:
        'El interior del horno, el refrigerador y los gabinetes empiezan seleccionados. Quite lo que esta casa no necesite.',
    },
    deep_clean_addons: {
      name: 'Complementos de limpieza profunda',
      description: 'Interior del horno, refrigerador y gabinetes, más zócalos y persianas.',
      notes: 'Empiezan seleccionados. Son estimados: edite los minutos antes de enviar la cotización.',
    },
    multifamily_common_areas: {
      name: 'Áreas comunes multifamiliares',
      description: 'Vestíbulo, pasillos, un tramo de escalera, elevador, lavandería, correo y basura.',
      notes:
        'Las medidas de pasillos, escaleras, lavandería, correo y basura son un punto de partida que puede editar.',
    },
    apartment_unit: {
      name: 'Unidad de apartamento',
      description: 'Una unidad de 2 dormitorios para una cotización multifamiliar, junto a las áreas comunes.',
      notes: 'La cantidad del grupo es el número de unidades iguales. Las cantidades son un punto de partida.',
    },
  },
};
